export default [
  {
    title: 'مدیریت آگهی ها',
    icon: 'bx bx-chalkboard',
    children: [
      {
        title: 'آگهی ها',
        route: { name: 'advertisement' },
        resource: 'AdvertisementManager',
        action: 'show',
      },
    ],
  },
]
